import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
import {
    makeSelectTimesheetValue
    // @ts-ignore
} from 'services/timesheet/selectors';

interface ConnectedProps {
    groupName?: string;
}

type Props = ConnectedProps;

export class SelectedTimesheetGroupNameValue extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { groupName } = this.props;
        if (!groupName) {
            return null;
        }
        return groupName;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    groupName: makeSelectTimesheetValue('groupName')
});

export default connect(mapStateToProps)(SelectedTimesheetGroupNameValue);
